import { FilterableInterface } from './filterable.interface';

export class Program implements FilterableInterface {
  constructor(
    public hash: string,
    public reference: string,
    public time: number,
    public timeDeviation?: number,
    public timeWithDeviation?: number,
    public tool?: string,
    public sourceHash?: string,
    public sourceName?: string,
    public partHash?: string,
    public partName?: string,
    public operationHash?: string,
    public operationName?: string,
    public operationIndex?: number,
    public index?: number
  ) { }

  get filterableData() {
    return this.reference.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/program.ts